<template>
  <div class="GlobalTable">
    <div class="button_top">
      <div class="faultBtn">
        <div
          :class="auditStatus === '00' ? 'active' : 'none'"
          @click="btnClick('00')"
        >
          未开始({{ applyNumber.unStartNum || 0 }})
        </div>
        <div
          :class="auditStatus === '01' ? 'active' : 'none'"
          @click="btnClick('01')"
        >
          进行中({{ applyNumber.ingNum || 0 }})
        </div>
        <div
          :class="auditStatus === '10' ? 'active' : 'none'"
          @click="btnClick('10')"
        >
          已结束({{ applyNumber.overNum || 0 }})
        </div>
      </div>
    </div>
    <GlobalTable
      ref="GlobalTable"
      v-if="refresh"
      v-loading="loading"
      :columns="tableColumns"
      :data="seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column
        label="活动海报"
        width="130px"
        slot="activityPoster"
        align="center"
      >
        <template slot-scope="{ row }">
          <img
            style="width: 380px; height: 54px; object-fit: contain"
            :src="row.activityPoster"
            @click="seeSampleImage(row.activityPoster)"
            alt=""
          />
        </template>
      </el-table-column>
      <el-table-column
        label="换新商品"
        width="130px"
        slot="productNum"
        align="center"
      >
        <template slot-scope="{ row }">
          <div class="wrapStyle">
            <span
              style="
                color: #0981ff;
                cursor: pointer;
                text-decoration: underline;
              "
              @click="goodsDialog(row, 'goodsAdded')"
              >{{ row.productNum }}</span
            >
            <span
              style="
                color: red;
                text-decoration: underline;
                cursor: pointer;
                color: #0981ff;
              "
              @click="goodsDialog(row, 'goods')"
              >添加商品</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="赠送商品"
        width="130px"
        slot="giftGoods"
        align="center"
      >
        <template slot-scope="{ row }">
          <div class="wrapStyle">
            <span
              style="
                color: #0981ff;
                cursor: pointer;
                text-decoration: underline;
              "
              @click="giftsDialog(row, 'goodsAdded')"
              >{{ row.giftNum || 0 }}</span
            >
            <span
              style="
                color: red;
                text-decoration: underline;
                cursor: pointer;
                color: #0981ff;
              "
              @click="giftsDialog(row, 'goods')"
              >添加赠品</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="参与门店"
        width="130px"
        slot="storeNum"
        align="center"
      >
        <template slot-scope="{ row }">
          <div class="wrapStyle">
            <span
              style="
                color: #0981ff;
                cursor: pointer;
                text-decoration: underline;
              "
              @click="storeDialog(row, 'storAdded')"
              >{{ row.storeNum }}</span
            >
            <span
              style="
                color: red;
                text-decoration: underline;
                cursor: pointer;
                color: #0981ff;
              "
              @click="storeDialog(row, 'store')"
              >添加门店</span
            >
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="生效操作人"
        width="130px"
        slot="startStaffPcName"
        align="center"
      >
        <template slot-scope="{ row }">
          <div class="wrapStyle">
            <span
              v-if="row.startStaffPcName != '' && row.startStaffPcName != null"
              >{{ row.startStaffPcName }}</span
            >
            <span v-else>自动生效</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="活动开始时间"
        width="130px"
        slot="startTime"
        align="center"
      >
        <template slot-scope="{ row }">
          <div class="wrapStyle">
            <span v-if="row.startTime != null">{{ row.startTime }}</span>
            <span v-else>{{ row.activityStart }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="活动结束时间"
        width="130px"
        slot="endTime"
        align="center"
      >
        <template slot-scope="{ row }">
          <div class="wrapStyle">
            <span v-if="row.endTime != null || row.activityEnd != null">{{
              row.endTime || row.activityEnd
            }}</span>
            <span v-else>商品售完自动结束</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="结束操作人"
        width="130px"
        slot="endStaffPcName"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.endStaffPcName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="结束原因"
        width="130px"
        slot="endCause"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-tooltip
            v-if="row.endCause"
            class="item"
            effect="dark"
            :content="row.endCause"
            placement="top"
          >
            <div class="Remarks">
              {{ row.endCause }}
            </div>
          </el-tooltip>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        :width="auditStatus == '00' ? 280 : auditStatus == '01' ? 240 : 160"
        label="操作"
        fixed="right"
        slot="operation"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-button
            v-if="auditStatus != '10'"
            size="mini"
            type="primary"
            round
            @click="auditTrunon(row, 'edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            v-if="auditStatus != '10'"
            type="danger"
            round
            @click="handleBtn(row, 'over')"
            >结束活动</el-button
          >
          <el-button
            size="mini"
            v-if="auditStatus === '00'"
            type="success"
            round
            @click="handleBtn(row, 'effective')"
            >立即生效</el-button
          >
          <el-button
            size="mini"
            v-if="auditStatus === '10'"
            type="success"
            round
            @click="auditTrunon(row, 'reUp')"
            >修改重新上架</el-button
          >
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 商品列表 -->
    <el-dialog
      :title="goodsListTitle"
      :visible.sync="goodsVisible"
      :close-on-click-modal="false"
      @close="btnClose"
      width="1050px"
    >
      <div class="flex staff-list-form" style="margin-bottom: 20px">
        <div class="flex">
          <span style="width: 70px">商品名称</span>
          <el-select
            v-model="productId"
            filterable
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex left">
          <span style="width: 70px">所属分类</span>
          <el-select
            v-model="goodsClass"
            filterable
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in goodClassList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex left" v-if="goodsListTitle != '添加商品'">
          <span style="width: 70px">商品状态</span>
          <el-select
            v-model="goodsState"
            filterable
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in goodsStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          type="primary"
          style="margin-left: 10px"
          size="small"
          @click="searchSettingGoods"
        >
          查询
        </el-button>
        <div style="margin-left: 10px" v-if="goodsListTitle != '添加商品'">
          <el-button
            type="danger"
            :disabled="selectRow.length === 0"
            size="small"
            @click="deleteRowProduct"
            >批量删除</el-button
          >
        </div>
      </div>
      <GlobalTable
        v-if="goodsClassFresh"
        ref="GlobalTable"
        :loading="goodsLoading"
        :columns="goodsColumns"
        :data="dialogGoodsList"
        :currentPage="goodsPage.pageNum"
        :total="this.goodsPage.total"
        isSelection
        @handleSelectionChange="selectChange"
        @handleCurrentChange="goodsSearch"
      >
        <el-table-column
          label="商品卖点"
          slot="Commoditybuy"
          align="center"
          v-if="goodsListTitle != '添加商品'"
        >
          <template slot-scope="{ row }">
            <p
              style="
                color: #0981ff;
                cursor: pointer;
                text-decoration: underline;
              "
              @click="seesellingPointList(row.sellingPointList)"
            >
              查看
            </p>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          label="商品状态"
          slot="shopState"
          align="center"
          v-if="goodsListTitle != '添加商品'"
        >
          <template slot-scope="{ row }">
            <span v-if="row.state == '00'">未上架</span>
            <span v-else-if="row.state == '03'">在售中</span>
            <span v-else-if="row.state == '05'">已售完</span>
            <span v-else-if="row.state == '10'">已到期</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          label="操作"
          slot="operation"
          align="center"
          v-if="goodsListTitle != '添加商品'"
        >
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              type="danger"
              @click="deleteRowProduct(row, 'delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer">
        <el-button
          v-if="goodsListTitle == '添加商品'"
          size="small"
          @click="btnClose"
          >取消</el-button
        >
        <el-button
          v-if="goodsListTitle == '添加商品'"
          type="primary"
          size="small"
          @click="addGoods"
          >确认添加</el-button
        >
        <el-button
          v-if="goodsListTitle != '添加商品'"
          size="small"
          @click="btnClose"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <!-- 赠品列表 -->
    <el-dialog
      :title="GiftTitle"
      :visible.sync="GiftVisible"
      :close-on-click-modal="false"
      @close="btnClose"
      width="1050px"
    >
      <div class="flex staff-list-form" style="margin-bottom: 20px">
        <div class="flex">
          <span style="width: 70px">商品名称</span>
          <el-select
            v-model="productId"
            filterable
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex left">
          <span style="width: 70px">商品分类</span>
          <el-select
            v-model="goodsClass"
            filterable
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in goodClassList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          type="primary"
          style="margin-left: 10px"
          size="small"
          @click="searchSettingGifts"
        >
          查询
        </el-button>
        <div style="margin-left: 10px" v-if="GiftTitle != '添加赠品'">
          <el-button
            type="danger"
            :disabled="selectRow.length === 0"
            size="small"
            @click="deleteRowGifts"
            >批量删除</el-button
          >
        </div>
      </div>
      <GlobalTable
        v-if="goodsClassFresh"
        ref="GlobalTable"
        :loading="goodsLoading"
        :columns="giftsColumns"
        :data="dialogGoodsList"
        :currentPage="goodsPage.pageNum"
        :total="goodsPage.total"
        isSelection
        @handleSelectionChange="selectChange"
        @handleCurrentChange="giftsSearch"
      >
        <el-table-column
          width="120"
          label="赠品状态"
          slot="shopState"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.state == '00'">未上架</span>
            <span v-else-if="row.state == '03'">在售中</span>
            <span v-else-if="row.state == '05'">已售完</span>
            <span v-else-if="row.state == '10'">已到期</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          label="赠品条件"
          slot="giftRuleType"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.giftRuleType == '00'">不压价也可赠送</span>
            <span v-else-if="row.giftRuleType == '01'"
              >压价金额≥赠品成本时可赠送</span
            >
            <span v-else-if="row.giftRuleType == '02'"
              >压价金额≥赠品售价时可赠送</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="商品卖点"
          slot="Commoditybuy"
          align="center"
          v-if="goodsListTitle != '添加商品'"
        >
          <template slot-scope="{ row }">
            <p
              style="
                color: #0981ff;
                cursor: pointer;
                text-decoration: underline;
              "
              @click="seesellingPointList(row.sellingPointList)"
            >
              查看
            </p>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          label="操作"
          slot="operation"
          align="center"
          v-if="GiftTitle != '添加商品'"
        >
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              type="danger"
              @click="deleteRowGifts(row, 'delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer">
        <el-button v-if="GiftTitle == '添加赠品'" size="small" @click="btnClose"
          >取消</el-button
        >
        <el-button
          v-if="GiftTitle == '添加赠品'"
          type="primary"
          size="small"
          @click="addGifts"
          >确认添加</el-button
        >
        <el-button v-if="GiftTitle != '添加赠品'" size="small" @click="btnClose"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看卖点 -->
    <el-dialog
      title="卖点详情"
      :visible.sync="prductsDialogVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <div style="margin-bottom: 20px">
        <div
          v-for="(item, index) in sellingPointList"
          :key="index"
          class="selDIAN"
        >
          <img :src="item.sellingPointIcon" alt="" />
          <div>
            <p>{{ item.sellingPointTitle }}</p>
            <span>{{ item.detailed || "暂无" }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="prductsDialogVisible = false"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 门店列表 -->
    <el-dialog
      :title="storeListTitle"
      :visible.sync="storeVisible"
      :close-on-click-modal="false"
      @close="btnClose"
      width="1300px"
    >
      <div class="flex staff-list-form" style="margin-bottom: 20px">
        <div class="flex">
          <span style="width: 70px">门店名称</span>
          <el-input
            v-model="storeName"
            size="small"
            clearable
            placeholder="请输入门店名称"
          ></el-input>
        </div>
        <div class="flex left">
          <span style="width: 80px">区域/总监</span>
          <el-select
            v-model="storePerson"
            filterable
            multiple
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in storePersonList"
              :key="item.staffId"
              :label="item.staffName"
              :value="item.staffId"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex left">
          <span style="width: 70px">门店标签</span>
          <el-select
            v-model="storeTag"
            filterable
            multiple
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in tagList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex left" v-if="storeListTitle != '添加门店'">
          <span style="width: 70px">门店状态</span>
          <el-select
            v-model="storeState"
            filterable
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in storeStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          type="primary"
          style="margin-left: 10px"
          size="small"
          @click="searchSettingStore"
        >
          查询
        </el-button>
        <div style="margin-left: 10px" v-if="storeListTitle != '添加门店'">
          <el-button
            type="danger"
            :disabled="selectRow.length === 0"
            size="small"
            @click="deleteRowStore"
            >批量删除</el-button
          >
        </div>
      </div>
      <GlobalTable
        ref="GlobalTable"
        v-if="storeFresh"
        :loading="storeLoading"
        :columns="storeColumns"
        :data="dialogStoreList"
        :currentPage="storePage.pageNum"
        :total="this.storePage.total"
        isSelection
        @handleSelectionChange="selectChangeStore"
        @handleCurrentChange="search"
      >
        <el-table-column label="门店标签" slot="tagList" align="center">
          <template slot-scope="{ row }">
            <span class="tagStyle" v-for="item in row.tagList" :key="item.id">{{
              item.tagName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已参与活动" slot="activityName" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              effect="dark"
              v-if="row.activityName"
              :content="row.activityName"
              placement="top"
            >
              <div class="Remarks">
                {{ row.activityName }}
              </div>
            </el-tooltip>
            <span v-else>{{ "暂未参加活动" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="门店启用状态" slot="isEnable" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isEnable ? "启用中" : "已禁用" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          label="操作"
          fixed="right"
          slot="operation"
          align="center"
          v-if="storeListTitle != '添加门店'"
        >
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              type="danger"
              @click="deleteRowStore(row, 'delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer">
        <el-button
          v-if="storeListTitle == '添加门店'"
          size="small"
          @click="btnClose"
          >取消</el-button
        >
        <el-button
          v-if="storeListTitle == '添加门店'"
          type="primary"
          size="small"
          @click="getStoreList"
          >确认添加</el-button
        >
        <el-button
          v-if="storeListTitle !== '添加门店'"
          size="small"
          @click="btnClose"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="操作提示"
      :visible.sync="deltoact"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="delcen2txt" v-if="gifttype == 'delete'">
        是否确认删除该商品？
      </div>
      <div class="delcen2txt" v-else>
        是否确认删除选中的<span style="color: red">{{ selectRow.length }}</span
        >个商品？
      </div>
      <div class="delbtn3">
        <el-button size="small" @click="deltoact = false">取消</el-button>
        <el-button type="primary" @click="delsure" size="small">确认</el-button>
      </div>
    </el-dialog>
    <!-- 立即生效 结束活动 提示操作 -->
    <el-dialog
      title="操作提示"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="430px"
      @closed="dialogVisible = false"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <div
          style="
            font-size: 16px;
            color: #666666;
            height: 40px;
            line-height: 50px;
          "
        >
          <div>是否确认立即{{ operateContent }}该活动？</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click.native="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="voucherBtnLoading"
          @click.native="handleSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看图片 -->
    <el-image-viewer
      :zIndex="99999"
      v-if="showViewer"
      :on-close="
        () => {
          imgList = [];
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
    <!-- 抽屉 -->
    <el-drawer
      title="编辑活动"
      :before-close="cancelForm"
      :visible.sync="drawerDialog"
      direction="rtl"
      custom-class="demo-drawer"
      :wrapper-closable="false"
      size="600px"
      ref="drawer"
    >
      <el-form
        :model="drawerInitData"
        ref="drawerForm"
        label-width="145px"
        label-position="left"
        :rules="drawerFormRules"
        class="el_from"
      >
        <el-form-item label="活动名称" prop="activityName">
          <el-input
            :disabled="auditStatus == '01'"
            type="text"
            maxlength="50"
            show-word-limit
            placeholder="输入活动名称,限50字"
            class="drawerWith"
            v-model.trim="drawerInitData.activityName"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="活动海报" prop="activityPoster" :required="true">
          <el-row style="display: flex; align-items: center">
            <el-col :span="7">
              <ElImgUpload
                :exist-image="drawerInitData.activityPoster"
                place-txt="建议图片尺寸为400px * 20px"
                @handleDelete="
                  handleUploadDelete(drawerInitData.activityPoster)
                "
                @handleChange="handleUploadChange($event)"
              />
            </el-col>
            <el-col :span="1">
              <el-button size="mini" type="warning" @click="referPic"
                >参考海报</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="活动开始时间" prop="activityStart">
          <div class="drawerWith">
            <el-date-picker
              v-model="drawerInitData.activityStart"
              type="date"
              :picker-options="pickerOptions0"
              value-format="yyyy-MM-dd"
              placeholder="选择活动开始时间"
              :disabled="auditStatus == '01'"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="活动结束时间" prop="activityEnd">
          <el-radio-group
            class="timeStyle"
            v-model="drawerInitData.activityEnd"
          >
            <el-row>
              <el-radio label="00">不定时：所有活动商品售完自动结束</el-radio>
            </el-row>
            <el-row style="margin-top: 20px">
              <el-radio label="01"
                ><span style="margin-right: 10px">定时结束</span>
                <div style="width: 500px; margin-top: 10px">
                  <el-date-picker
                    v-model="expireTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束时间"
                    :picker-options="pickerOptions1"
                    :disabled="drawerInitData.activityEnd == '00'"
                  >
                  </el-date-picker>
                </div>
              </el-radio>
            </el-row>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要保存顾客信息(姓名、手机号)">
          <el-radio-group v-model="drawerInitData.isSave">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="margin-top: -15px">
          <p style="font-size: 15px">换新补贴设置</p>
          <div class="huanxin">
            <el-form-item label="换新补贴方式" label-width="110px" required>
              <el-radio-group v-model="drawerInitData.subsidyWay">
                <el-radio :disabled="auditStatus === '01'" label="00">
                  旧机加价补贴
                </el-radio>
                <el-radio :disabled="auditStatus === '01'" label="01"
                  >换新抵扣券补贴</el-radio
                >
              </el-radio-group>
              <p class="wen_text">
                <span style="margin-right: 20px"
                  >顾客先收款旧机+新机补贴,再付款购买新机</span
                ><span>旧机与新机财务单独核算</span>
              </p>
            </el-form-item>
            <el-form-item label="启用赠送礼品" label-width="110px" required>
              <el-switch
                :disabled="auditStatus === '01'"
                v-model="drawerInitData.isOpenGift"
              >
              </el-switch>
            </el-form-item>
            <p style="font-size: 12px; color: #666666; margin-left: 110px">
              {{
                drawerInitData.isOpenGift
                  ? "提交后在活动列表设置赠品"
                  : "该活动暂不需要设置赠品"
              }}
            </p>
          </div>
        </div>
        <el-row style="margin-top: 60px">
          <el-col :span="7" :offset="17">
            <el-button size="small" @click="cancelForm">取消</el-button>
            <el-button size="small" type="primary" @click="handleClose"
              >确认</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 选择海报 -->
    <el-dialog
      title="选择海报"
      :visible.sync="posterDialogVisible"
      :close-on-click-modal="false"
      width="880px"
    >
      <ul
        style="
          padding: 20px;
          width: 840px;
          height: 300px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        "
      >
        <li
          v-for="(item, index) in posterList"
          :key="index"
          style="width: 370px"
        >
          <div
            style="display: flex; justify-content: center; align-items: center"
            @click="choosePoster(index)"
          >
            <img
              v-if="isCheckPoster === index"
              style="width: 18px; cursor: pointer"
              src="https://img.fanxinghuishou.cn/20231216/481566005.png"
              alt=""
            />
            <img
              v-else
              style="width: 18px; cursor: pointer"
              src="https://img.fanxinghuishou.cn/20231216/607204106.png"
              alt=""
            />
            <div>
              <img
                style="
                  width: 370px;
                  height: 54px;
                  border-radius: 10px;
                  margin-left: 10px;
                  cursor: pointer;
                "
                :src="item.posterImg"
                alt=""
              />
            </div>
          </div>
          <span
            class="text-down"
            style="display: flex; justify-content: end; margin-top: 5px"
            @click="downPoster(item)"
            >下载文件</span
          >
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="posterDialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitAdd">确定选择</el-button>
      </span>
    </el-dialog>
    <!-- 创建成功 -->
    <el-dialog
      title="创建成功"
      :visible.sync="createShow"
      :close-on-click-modal="false"
      width="300px"
      @closed="automaticClosed"
    >
      <div class="enable-tip">
        <div>活动已创建成功，请在活动开始前，添加活动商品及参与门店</div>
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" @click.native="creatSubmit"
          >知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import ElImgUpload from "../../../components/global/components/elements/upload-element";
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "Table",
  components: { ElImageViewer, ElImgUpload },
  data() {
    let validateEndTime = (rule, value, callback) => {
      if (value == "01") {
        if (!this.expireTime) {
          callback(new Error("请选择定时结束时间"));
        } else {
          if (
            this.compareDate(this.drawerInitData.activityStart, this.expireTime)
          ) {
            callback();
          } else {
            callback(new Error("活动结束日期不能在起始日期前，请重新选择"));
          }
        }
      } else {
        callback();
      }
    };
    return {
      deltoact: false,
      gifttype: "",
      giftdata: {},
      isEdit: false,
      storeFresh: true,
      goodsClassFresh: true,
      isCheckPoster: "",
      // 海报start
      posterDialogVisible: false,
      posterList: [],
      // 海报end
      // 抽屉
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          return (
            time.getTime() <
              new Date(this.drawerInitData.activityStart) - 8.64e7 ||
            time.getTime() <= Date.now()
          );
        },
      },
      drawerDialog: false,
      expireTime: null,
      drawerInitData: {
        isOpenGift: false,
        subsidyWay: "00",
        activityName: "",
        activityPoster: "",
        activityStart: "",
        activityEnd: "00",
        isSave: true,
      },
      drawerFormRules: {
        activityName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入活动名称",
            max: 50,
          },
        ],
        activityStart: [
          {
            required: true,
            trigger: "blur",
            message: "请选择活动开始时间",
          },
        ],
        isSave: [
          {
            required: true,
            trigger: "blur",
            message: "是否需要保存顾客信息(姓名、手机号)",
          },
        ],
        activityPoster: [
          {
            required: true,
            trigger: "blur",
            message: "请上传活动海报",
          },
        ],
        activityEnd: [
          {
            required: true,
            trigger: "blur",
            message: "请选择活动结束时间",
          },
          { validator: validateEndTime, trigger: "blur" },
        ],
      },
      posterData: [],
      posterformRules: {},
      // posterDialogShow:false,
      createShow: false,
      dialogVisible: false,
      operateContent: "",
      btnLoading: false,
      // 海报放大
      imgList: [],
      showViewer: false,
      // end
      goodsVisible: false,
      GiftVisible: false,
      storeVisible: false,
      GiftTitle: "添加赠品",
      goodsListTitle: "添加商品",
      storeListTitle: "添加门店",
      addedGoods: 0,
      addedStore: 0,
      goodsLoading: false,
      storeLoading: false,
      currentRow: {},
      selectRow: [],
      dialogGoodsList: [],
      dialogStoreList: [],
      storePage: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
      },
      goodsPage: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
      },
      giftsColumns: [],
      goodsColumns: [],
      storeColumns: [],
      goodsParams: {
        id: "",
      },
      storeParams: {
        id: "",
      },
      goodClassList: [],
      goodsStateList: [
        {
          label: "未上架",
          value: "00",
        },
        {
          label: "在售中",
          value: "03",
        },
        {
          label: "已售完",
          value: "05",
        },
        {
          label: "已过期",
          value: "10",
        },
      ],
      productId: "",
      productList: [],
      goodsClass: "",
      goodsState: "",
      storeName: "",
      storePerson: [],
      storeTag: [],
      storePersonList: [],
      tagList: [],
      storeState: null,
      storeStateList: [
        {
          label: "启用中",
          value: true,
        },
        {
          label: "已禁用",
          value: false,
        },
      ],

      repairTitle: "",
      repairResult: "",
      repairLoading: false,
      loadingText: "",
      repairShow: false,
      refresh: true,
      loading: false,
      seachDataList: [],
      auditStatus: "00",
      RemarksTitle: "",
      RemarksShow: false,
      masterNote: "",
      butLoading: false,
      voucherBtnLoading: false,
      rowId: "",
      btnType: "",
      command: "",
      operation: {},
      applyNumber: {},
      voucherList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageNum: 1,
      failed: true,
      //弹窗
      FollowNoShow: false,
      dialogTitle: "", // 标题
      FollowNoTitle: "",
      dialogWidth: "600px",
      dialongDecide: "",
      middleColumns: [
        { label: "活动编号", prop: "activityNo" },
        { label: "活动名称", prop: "activityName" },
        { slotName: "activityPoster" }, //活动海报
        { slotName: "productNum" }, //换新商品
        { slotName: "giftGoods" }, //赠送商品
        { slotName: "storeNum" }, //参与门店
        { label: "创建人", prop: "createStaffPcName" },
        { label: "创建时间", prop: "createTime" },
        { slotName: "startTime" }, //活动开始时间
        { slotName: "endTime" }, //活动结束时间
        { slotName: "operation" },
      ],
      tableColumns: [],
      sellingPointList: [],
      prductsDialogVisible: false,
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  created() {
    this.tableColumns = [...this.middleColumns];
    this.handleCurrentChange();
  },
  watch: {
    SeachParams(newVal) {
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
    "drawerInitData.activityEnd": {
      handler(val) {
        if (val == "00") {
          this.expireTime = null;
        }
      },
    },
  },
  methods: {
    seesellingPointList(list) {
      this.sellingPointList = list;
      this.prductsDialogVisible = true;
    },
    // 比较两个日期
    compareDate(start, end) {
      console.log("比较两个日期", start, end);
      return new Date(start).getTime() <= new Date(end).getTime();
    },
    // 参考海报
    referPic() {
      _api.getPosterList().then((res) => {
        if (res.code == 1) {
          console.log(222, res);
          this.posterList = res.data;
          this.posterDialogVisible = true;
        }
      });
    },
    // 提交海报
    submitAdd() {
      this.drawerInitData.activityPoster =
        this.posterList[this.isCheckPoster].posterImg;
      console.log("提交海报", this.drawerInitData.activityPoster);
      this.posterDialogVisible = false;
    },
    // 选择海报
    choosePoster(index) {
      this.isCheckPoster = index;
    },
    downPoster(item) {
      const url = item.posterOriginalFile; // 下载文件的url
      const link = document.createElement("a");
      link.href = url;
      link.download = "活动海报.zip"; // 下载文件的名称
      link.click();
    },
    handleUploadDelete() {
      this.drawerInitData.activityPoster = "";
    },
    handleUploadChange(res) {
      this.drawerInitData.activityPoster = res;
    },
    // 海报end
    creatSubmit() {
      this.createShow = false;
      this.handleCurrentChange();
    },
    // 抽屉
    handleClose() {
      this.$refs["drawerForm"].validate((valid) => {
        if (valid) {
          const params = {
            activityEnd:
              this.drawerInitData.activityEnd == "01"
                ? this.expireTime
                  ? moment(this.expireTime).endOf("day").format("x")
                  : null
                : null,
            isOpenGift: this.drawerInitData.isOpenGift,
            subsidyWay: this.drawerInitData.subsidyWay,
            activityName: this.drawerInitData.activityName,
            activityPoster: this.drawerInitData.activityPoster,
            activityStart: moment(this.drawerInitData.activityStart)
              .startOf("day")
              .format("x"),
            isSave: this.drawerInitData.isSave,
            isTiming: this.drawerInitData.activityEnd == "01" ? true : false,
          };

          if (this.isEdit) {
            (params.activityId = this.drawerInitData.activityId),
              _api.editActivity(params).then((res) => {
                if (res.code === 1) {
                  this.createShow = true;
                  this.cancelForm();
                }
              });
          } else {
            _api.addActivity(params).then((res) => {
              if (res.code === 1) {
                this.createShow = true;
                this.cancelForm();
              }
            });
          }
        }
      });
    },
    cancelForm() {
      this.drawerDialog = false;
      this.drawerInitData = {
        isOpenGift: false,
        subsidyWay: "00",
        activityName: "",
        activityPoster: "",
        activityStart: null,
        activityEnd: "00",
        isSave: true,
        isTiming: false,
      };
      this.expireTime = null;
      this.isEdit = false;
      this.$refs["drawerForm"].resetFields();
    },
    automaticClosed() {
      this.createShow = false;
    },
    // 查看示例图大图
    seeSampleImage(posterImg) {
      this.imgList = [];
      this.showViewer = true;
      this.imgList.push(posterImg);
    },
    // 删除门店行
    deleteRowStore(row, type) {
      const params = {
        activityId: this.currentRow.activityId,
        // storeIdList: this.selectRow.length ? this.selectRow : [row.id]
        storeIdList: type == "delete" ? [row.id] : this.selectRow,
      };
      _api.removeStore(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.storeVisible = false;
          this.selectRow = [];
          this.handleCurrentChange();
        }
      });
    },
    // 删除商品行
    deleteRowProduct(row, type) {
      const params = {
        activityId: this.currentRow.activityId,
        // productIdList: this.selectRow.length ? this.selectRow : [row.productId]
        productIdList: type == "delete" ? [row.productId] : this.selectRow,
      };
      _api.deleteActivityaProduct(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.goodsVisible = false;
          this.selectRow = [];
          this.handleCurrentChange();
        }
      });
    },
    // 删除赠品行
    deleteRowGifts(row, type) {
      this.gifttype = type;
      this.giftdata = row;
      this.deltoact = true;
    },
    //确认删除
    delsure() {
      const params = {
        activityId: this.currentRow.activityId,
        productIdList:
          this.gifttype == "delete"
            ? [this.giftdata.productId]
            : this.selectRow,
      };
      _api.deleteActivityaGifts(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.GiftVisible = false;
          this.deltoact = false;
          this.selectRow = [];
          this.dialogGoodsList = [];
          this.handleCurrentChange();
        }
      });
    },
    goodsSearch(val) {
      if (val) {
        this.goodsPage.pageNum = val;
      }
      if (this.goodsListTitle == "添加商品") {
        this.paddingGoodsListData(false);
      } else {
        this.addProduct(false);
      }
    },
    // dialog查询
    searchSettingGoods() {
      this.goodsPage.pageNum = 1;
      if (this.goodsListTitle == "添加商品") {
        this.paddingGoodsListData(false);
      } else {
        this.addProduct(false);
      }
    },
    giftsSearch(val) {
      if (val) {
        this.goodsPage.pageNum = val;
      }
      if (this.GiftTitle == "添加赠品") {
        this.paddingGoodsListData(true);
      } else {
        this.addProduct(true);
      }
    },
    // dialog查询
    searchSettingGifts() {
      this.goodsPage.pageNum = 1;
      if (this.GiftTitle == "添加赠品") {
        this.paddingGoodsListData(true);
      } else {
        this.addProduct(true);
      }
    },
    search(val) {
      if (val) {
        this.storePage.pageNum = val;
      }
      if (this.storeListTitle == "添加门店") {
        this.paddingStoreListData();
      } else {
        this.storeListData();
      }
    },
    searchSettingStore() {
      this.storePage.pageNum = 1;
      if (this.storeListTitle == "添加门店") {
        this.paddingStoreListData();
      } else {
        this.storeListData();
      }
    },
    // 列表关闭
    btnClose() {
      this.productId = "";
      this.goodsClass = "";
      this.goodsState = "";
      this.storeName = "";
      this.storePerson = [];
      this.storeTag = [];
      this.storeState = null;
      this.storePage = {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      };
      this.goodsPage = {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      };
      this.GiftVisible = false;
      this.goodsVisible = false;
      this.storeVisible = false;
    },
    goodsDialog(row, val) {
      this.currentRow = row;
      this.goodsClassFresh = false;
      this.goodsVisible = true;
      if (val == "goods") {
        this.goodsListTitle = "添加商品";
        this.goodsColumns = [
          { label: "商品名称", prop: "productName" },
          { label: "商品分类", prop: "typeName" },
          { label: "补贴金额（元）", prop: "subsidyPrice" },
          { label: "商品当前数量", prop: "stock" },
        ];
        this.goodsClassFresh = true;
        this.paddingGoodsListData(false);
      } else {
        this.goodsColumns = [
          { label: "商品名称", prop: "productName" },
          { label: "商品分类", prop: "typeName" },
          { slotName: "shopState" },
          { label: "商品成本(元)", prop: "cost" },
          { label: "商品售价(元)", prop: "sellPrice" },
          { label: "补贴金额(元)", prop: "subsidyPrice" },
          { slotName: "Commoditybuy" },
          { label: "添加时间", prop: "createTime" },
          { label: "商品数量", prop: "stock" },
          { slotName: "operation" },
        ];
        this.goodsClassFresh = true;
        this.addProduct(false);
      }
      this.getGoodsClassSelectList();
      this.productSelect();
    },
    giftsDialog(row, val) {
      this.currentRow = row;
      this.goodsClassFresh = false;
      this.GiftVisible = true;
      if (val == "goods") {
        this.GiftTitle = "添加赠品";
        this.giftsColumns = [
          { label: "商品名称", prop: "productName" },
          { label: "商品分类", prop: "typeName" },
          { slotName: "shopState" },
          { label: "成本(元)", prop: "cost" },
          { label: "售价(元)", prop: "sellPrice" },
          { label: "当前库存", prop: "stock" },
          { slotName: "giftRuleType" },
        ];
        this.goodsClassFresh = true;
        this.paddingGoodsListData(true);
      } else {
        this.GiftTitle = "已添加赠品";
        this.giftsColumns = [
          { label: "商品名称", prop: "productName" },
          { label: "商品分类", prop: "typeName" },
          { slotName: "shopState" },
          { label: "成本(元)", prop: "cost" },
          { label: "售价(元)", prop: "sellPrice" },
          { label: "当前库存", prop: "stock" },
          // { label: "赠品条件", prop: "stock" },
          { slotName: "giftRuleType" },
          { slotName: "Commoditybuy" },
          { slotName: "operation" },
        ];
        this.goodsClassFresh = true;
        this.addProduct(true);
      }
      this.getGoodsClassSelectList();
      this.productSelect();
    },
    // 已添加商品列表
    addProduct(isOpenGift) {
      const params = {
        activityId: this.currentRow.activityId,
        productId: this.productId,
        pageNum: this.goodsPage.pageNum,
        pageSize: this.goodsPage.pageSize,
        isOpenGift, //是否启用赠品
        state: this.goodsState,
        typeCode: this.goodsClass,
      };
      _api.addActivityProduct(params).then((res) => {
        if (res.code === 1) {
          this.dialogGoodsList = res.data.records;
          this.addedGoods = res.data.total;
          this.goodsListTitle = `已添加商品(${this.addedGoods})`;
          this.goodsPage.pageNum = res.data.current;
          this.goodsPage.total = res.data.total;
        }
      });
    },
    // 待添加商品 -- 查询
    paddingGoodsListData(isOpenGift) {
      const params = {
        activityId: this.currentRow.activityId,
        productId: this.productId,
        pageNum: this.goodsPage.pageNum,
        pageSize: this.goodsPage.pageSize,
        isOpenGift, //是否启用赠品
        state: this.goodsState,
        typeCode: this.goodsClass,
      };
      _api.paddingAddGoodsList(params).then((res) => {
        if (res.code == 1) {
          this.dialogGoodsList = res.data.records;
          this.goodsPage.pageNum = res.data.current;
          this.goodsPage.total = res.data.total;
        }
      });
    },
    // 获取门店标签
    getStoreTagSelect() {
      _api.getStoreTagSelect().then((res) => {
        console.log(11, res);
        this.tagList = res.data;
      });
    },
    //商品下拉
    productSelect() {
      _api.productSelect().then((res) => {
        this.productList = res.data;
      });
    },
    // 商品所属分类下拉
    getGoodsClassSelectList() {
      _api.typeSelect({ companyId: this.companyId }).then((res) => {
        if (res.code === 1) {
          this.goodClassList = res.data;
        }
      });
    },
    storeDialog(row, val) {
      this.currentRow = row;
      this.storeVisible = true;
      this.storeFresh = false;
      if (val == "store") {
        this.storeListTitle = "添加门店";
        this.storeColumns = [
          { label: "区域/总监", prop: "inspectorName" },
          { slotName: "tagList" },
          { label: "门店名称", prop: "storeName" },
          { slotName: "activityName" },
          { slotName: "isEnable" },
        ];
        this.storeFresh = true;
        this.paddingStoreListData();
      } else {
        this.storeColumns = [
          { label: "区域/总监", prop: "inspectorName" },
          { slotName: "tagList" },
          { label: "门店名称", prop: "storeName" },
          { slotName: "isEnable" },
          { label: "添加时间", prop: "createTime" },
          { slotName: "operation" },
        ];
        this.storeFresh = true;
        this.storeListData();
      }
      this.getPersonSelectList();
      this.getStoreTagSelect();
    },
    storeListData(val) {
      if (val) {
        this.storePage.pageNum = val;
      }
      const params = {
        activityId: this.currentRow.activityId,
        inspectorIds: this.storePerson,
        isEnable: this.storeState,
        storeName: this.storeName,
        tagIds: this.storeTag,
        pageNum: this.storePage.pageNum,
        pageSize: this.storePage.pageSize,
      };
      _api.getAddStoreList(params).then((res) => {
        if (res.code == 1) {
          console.log("门店下拉", res);
          this.dialogStoreList = res.data.records;
          this.addedStore = res.data.total;
          this.storeListTitle = `已添加门店(${this.addedStore})`;
          this.storePage.pageNum = res.data.current;
          this.storePage.total = res.data.total;
        }
      });
    },
    paddingStoreListData() {
      const params = {
        activityId: this.currentRow.activityId,
        inspectorIds: this.storePerson,
        isEnable: this.storeState,
        storeName: this.storeName,
        tagIds: this.storeTag,
        pageNum: this.storePage.pageNum,
        pageSize: this.storePage.pageSize,
      };
      _api.paddingAddStoreList(params).then((res) => {
        if (res.code == 1) {
          this.dialogStoreList = res.data.records;
          this.storePage.pageNum = res.data.current;
          this.storePage.total = res.data.total;
        }
      });
    },
    selectChange(val) {
      this.selectRow = val.map((el) => el.productId);
    },
    selectChangeStore(val) {
      this.selectRow = val.map((el) => el.id);
    },
    // 门店区域/总监下拉
    getPersonSelectList() {
      _api.getNotPInspectorSelect({ scope: "00" }).then((res) => {
        if (res.code === 1) {
          this.storePersonList = res.data;
        }
      });
    },
    // 添加门店
    getStoreList() {
      // 006
      this.storeLoading = true;
      const params = {
        activityId: this.currentRow.activityId,
        storeIdList: this.selectRow,
      };
      _api.addActivityStore(params).then((res) => {
        if (res.code === 1) {
          this.handleCurrentChange();
          this.$message.success(res.msg);
          this.storeLoading = false;
          this.btnClose();
          this.selectRow = [];
        }
      });
    },
    // 商品列表添加
    addGoods() {
      this.goodsLoading = true;
      const params = {
        activityId: this.currentRow.activityId,
        productIdList: this.selectRow,
      };
      _api.addActivityaProduct(params).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.goodsLoading = false;
          this.btnClose();
          this.handleCurrentChange();
        }
      });
    },
    //赠品添加
    addGifts() {
      if (this.selectRow.length === 0) {
        return this.$message.error("请至少选择一个商品！");
      }
      this.goodsLoading = true;
      const params = {
        activityId: this.currentRow.activityId,
        productIdList: this.selectRow,
      };
      _api.addActivityagift(params).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.goodsLoading = false;
          this.btnClose();
          this.handleCurrentChange();
        }
      });
    },
    auditTrunon(row, type) {
      this.currentRow = row;
      console.log(12345, row, type);
      this.drawerDialog = true;
      this.drawerInitData = {
        isOpenGift: this.currentRow.isOpenGift,
        subsidyWay: this.currentRow.subsidyWay,
        activityId: this.currentRow.activityId,
        activityName: this.currentRow.activityName,
        activityPoster: this.currentRow.activityPoster,
        activityStart: this.currentRow.activityStart,
        activityEnd: this.currentRow.isTiming ? "01" : "00", //活动结束时间 定时01
        isSave: this.currentRow.isSave,
      };
      this.expireTime = this.currentRow.isTiming
        ? this.currentRow.activityEnd
        : null;
      if (type == "edit") {
        this.isEdit = true;
      }
    },
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.pageNum = val;
        this.page.pageNum = val;
      }
      const baseRequest = {
        state: this.auditStatus,
        activityName: this.SeachParams.activityName,
        startTime: this.SeachParams.startTime,
        endTime: this.SeachParams.endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.refresh = false;
      this.loading = true;
      _api
        .renewActivityList(baseRequest)
        .then((res) => {
          if (res.code === 1) {
            console.log(1234, res);
            this.seachDataList = res.data.list.records;
            this.applyNumber.unStartNum = res.data.unStartNum;
            this.applyNumber.ingNum = res.data.ingNum;
            this.applyNumber.overNum = res.data.overNum;
            this.page.total = res.data.list.total;
            this.page.pageNum = res.data.list.current;
            this.loading = false;
            this.refresh = true;
          }
          if (typeof this.SeachParams.disuseLoding === "function") {
            this.SeachParams.disuseLoding();
          }
        })
        .catch(() => {
          if (typeof this.SeachParams.disuseLoding === "function") {
            this.SeachParams.disuseLoding();
          }
        });
    },
    repairClosed() {
      this.repairShow = false;
    },
    // 弹出备注弹框
    handleBtn(row, type) {
      this.currentRow = row;
      if (type == "over") {
        this.operateContent = "结束";
      } else {
        this.operateContent = "生效";
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.voucherBtnLoading = true;
      let params = {
        activityId: this.currentRow.activityId,
      };
      if (this.operateContent == "结束") {
        _api
          .endActivity(params)
          .then((res) => {
            this.$message.success("操作成功");
            this.voucherBtnLoading = false;
            this.dialogVisible = false;
            this.handleCurrentChange();
          })
          .catch(() => {
            this.voucherBtnLoading = false;
          });
      } else {
        _api
          .startActivity(params)
          .then((res) => {
            this.$message.success("操作成功");
            this.voucherBtnLoading = false;
            this.dialogVisible = false;
            this.handleCurrentChange();
          })
          .catch(() => {
            this.voucherBtnLoading = false;
          });
      }
    },
    // 关闭备注弹框
    remarksClosed() {
      this.RemarksShow = false;
      this.masterNote = "";
    },
    btnClick(type) {
      this.auditStatus = type;
      this.refresh = false;
      const columns = [...this.middleColumns];
      if (type == "01") {
        columns.splice(10, 0, { slotName: "startStaffPcName" });
      } else if (type == "10") {
        columns.splice(
          10,
          0,
          { slotName: "endStaffPcName" },
          { slotName: "endCause" }
        );
      }
      this.tableColumns = columns;
      this.refresh = true;
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  .wrapStyle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .staff-list-form {
    .el-input {
      width: 170px;
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .button_top {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .repair-conent {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .faultBtn {
    //width: 432px;
    height: 34px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;
    .active {
      text-align: center;
      color: white;
      padding: 0 20px;
      // width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981ff;
      border-radius: 20px;
    }
    .none {
      text-align: center;
      color: #333;
      padding: 0 20px;
      // width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }
  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }
  .text-down {
    text-decoration: underline;
    color: #0981ff;
    cursor: pointer;
  }
  .operation-btn {
    /deep/.el-button {
      margin-left: 0;
    }
  }
  .remarks-tip {
    color: #0981ff;
    font-size: 16px;
    padding-left: 10px;
    border-left: 3px solid;
    margin-bottom: 10px;
  }
  .command {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
}

.call_accounts_info {
  margin: 10px 0;
}

.call_accounts_check {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 14px;
}

.call_accounts_result {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.el_from {
  margin-left: 30px;
  .form_flex_cont {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }
  .drawerWith {
    width: 500px;
  }
  .timeStyle {
    margin-top: 15px;
  }
}
.tagStyle {
  border: 1px solid #0981ff;
  border-radius: 10px;
  padding: 3px 10px;
  color: #0981ff;
  margin-right: 10px;
}
.left {
  margin-left: 5px;
}
.delcen2txt {
  text-align: center;
  margin-top: 20px;
}

.delbtn3 {
  padding: 40px 150px 20px 140px;
  display: flex;
  justify-content: space-between;
}
.huanxin {
  padding-left: 20px;
  /deep/.el-form-item {
    margin-bottom: 0px;
  }
  /deep/.el-radio:nth-of-type(1) {
    margin-right: 130px;
  }
}
.wen_text {
  font-size: 12px;
  color: #666666;
  margin-top: -5px;
  line-height: 20px;
}
// /deep/.el-drawer__body{
//   overflow: auto;
// }
.selDIAN {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding: 10px;
  width: 760px;
  min-height: 50px;
  background: #f0f5ff;
  border-radius: 4px;
  img {
    width: 50px;
    height: 50px;
    margin-right: 12px;
  }
  p {
    font-family: FZLanTingHei-B-GBK;
    font-weight: 400;
    font-size: 14px;
  }
  span {
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
  }
}
</style>
